export default __webpack_public_path__ + "static/media/holdings-img.87b48736.jpg";